import { ImageBackground } from 'expo-image';

import { createMqStyles, useMqSelect } from '@fhs/ui';

import { CtaButton } from '../shared/cta-button';

export function CapreseCard({ url }: { url: string }) {
  const mqStyles = useMqStyles();
  const backgroundSource = useMqSelect(
    {
      $gteDesktopLg: require('./desktop.webp'),
    },
    require('./tablet.webp')
  );
  return (
    <ImageBackground
      alt="New Caprese Sandwich. Available in veggie or chicken. At participating restaurants in Canada for a limited time."
      source={backgroundSource}
      placeholder={{ thumbhash: 'bUkGC4KvpoVdhciSMIAAUTs=' }}
      style={mqStyles.background}
    >
      <CtaButton href={url} style={mqStyles.button} />
    </ImageBackground>
  );
}

const useMqStyles = createMqStyles({
  background: {
    $base: {
      aspectRatio: 1024 / 504,
    },
    $gteDesktopLg: {
      aspectRatio: 1920 / 757,
    },
  },
  button: {
    $base: {
      position: 'absolute',
      top: '48%',
      left: '10%',
      transform: 'translateX(-50%)',
    },
    $gteDesktopLg: {
      top: '43%',
    },
  },
});
